var render = function render(){var _vm=this,_c=_vm._self._c;return (typeof _vm.contactRequest.unsubscribeRequestId === 'string')?_c('span',{staticClass:"inline-flex items-center rounded-full bg-red-100 px-3 py-0.5 text-sm font-medium text-red-800"},[_vm._v(_vm._s(_vm.$t('global.unsubscribed')))]):_c('BaseButton',{attrs:{"primary":"","outline":""},on:{"click":_vm.showUnsubscribeDialog}},[_vm._v(" Unsubscribe ")])
}
var staticRenderFns = []

export { render, staticRenderFns }